<div class="d-flex">
  <div>
    <button
      [ngClass]="
        selectedOverview === 'new'
          ? 'selected-button border-badge-selected'
          : 'non-selected-button border-badge'
      "
      (click)="changeSelectedView('new')"
      type="button"
      mat-button
    >
      <span
        class="span-badge-margin"
        [ngClass]="
          selectedOverview === 'new' ? 'border-badge-selected' : 'border-badge'
        "
        matBadge="{{ countNew }}"
        [matBadgeHidden]="countNew == null || countNew === 0"
        [matBadgeSize]="'medium'"
        matBadgeOverlap="false"
      ></span>
      Nieuwe
    </button>
  </div>
  <div>
    <button
      [ngClass]="
        selectedOverview === 'quotation'
          ? 'selected-button border-badge-selected'
          : 'non-selected-button border-badge'
      "
      (click)="changeSelectedView('quotation')"
      type="button"
      mat-button
    >
      <span
        class="span-badge-margin"
        [ngClass]="
          selectedOverview === 'quotation'
            ? 'border-badge-selected'
            : 'border-badge'
        "
        matBadge="{{ countQuotation }}"
        [matBadgeHidden]="countQuotation == null || countQuotation === 0"
        [matBadgeSize]="'medium'"
        matBadgeOverlap="false"
      ></span>
      Offerte
    </button>
  </div>
  <div>
    <button
      [ngClass]="
        selectedOverview === 'site-visit'
          ? 'selected-button border-badge-selected'
          : 'non-selected-button border-badge'
      "
      (click)="changeSelectedView('site-visit')"
      type="button"
      mat-button
    >
      <span
        class="span-badge-margin"
        [ngClass]="
          selectedOverview === 'site-visit'
            ? 'border-badge-selected'
            : 'border-badge'
        "
        matBadge="{{ countSiteVisit }}"
        [matBadgeHidden]="countSiteVisit == null || countSiteVisit === 0"
        [matBadgeSize]="'medium'"
        matBadgeOverlap="false"
      ></span>
      Werfbezoek
    </button>
  </div>
  <div>
    <button
      [ngClass]="
        selectedOverview === 'pending'
          ? 'selected-button border-badge-selected middle'
          : 'non-selected-button border-badge middle'
      "
      (click)="changeSelectedView('pending')"
      type="button"
      mat-button
    >
      <span
        class="span-badge-margin"
        [ngClass]="
          selectedOverview === 'pending'
            ? 'border-badge-selected'
            : 'border-badge'
        "
        matBadge="{{ countPending }}"
        [matBadgeHidden]="countPending == null || countPending === 0"
        [matBadgeSize]="'medium'"
        matBadgeOverlap="false"
      ></span>
      <span>In behandeling</span>
    </button>
  </div>

  <div>
    <button
      [ngClass]="
        selectedOverview === 'invoicing'
          ? 'selected-button border-badge-selected'
          : 'non-selected-button border-badge'
      "
      (click)="changeSelectedView('invoicing')"
      type="button"
      mat-button
      class="border-badge"
    >
      <span
        class="span-badge-margin"
        [ngClass]="
          selectedOverview === 'invoicing'
            ? 'border-badge-selected'
            : 'border-badge'
        "
        matBadge="{{ countInvoicing }}"
        [matBadgeHidden]="countInvoicing == null || countInvoicing === 0"
        [matBadgeSize]="'medium'"
        matBadgeOverlap="false"
      ></span>
      Te factureren
    </button>
  </div>
  <div>
    <button
      [ngClass]="
        selectedOverview === 'executed'
          ? 'selected-button border-badge-selected'
          : 'non-selected-button border-badge'
      "
      (click)="changeSelectedView('executed')"
      type="button"
      mat-button
      class="border-badge no-badge"
    >
      Uitgevoerd
    </button>
  </div>
  <div>
    <button
      [ngClass]="
        selectedOverview === 'archived'
          ? 'selected-button border-badge-selected'
          : 'non-selected-button border-badge'
      "
      (click)="changeSelectedView('archived')"
      type="button"
      mat-button
      class="border-badge no-badge"
    >
      Archief
    </button>
  </div>
  <div>
    <button
      [ngClass]="
        selectedOverview === 'delayed'
          ? 'selected-button border-badge-selected'
          : 'non-selected-button border-badge'
      "
      (click)="changeSelectedView('delayed')"
      type="button"
      mat-button
      class="border-badge no-badge"
    >
      Uitgesteld
    </button>
  </div>
  <div>
    <button
      [ngClass]="
        selectedOverview === 'search'
          ? 'selected-button'
          : 'non-selected-button'
      "
      (click)="changeSelectedView('search')"
      type="button"
      mat-button
      class="border-badge no-badge"
    >
      Zoek
    </button>
  </div>
  <div>
    <button
      [ngClass]="
        selectedOverview === 'most-recent-placement'
          ? 'selected-button'
          : 'non-selected-button'
      "
      (click)="changeSelectedView('most-recent-placement')"
      type="button"
      mat-button
      class="border-badge no-badge"
    >
      Laatste plaatsingen
    </button>
  </div>
  <div class="end-flex align-with-project-type-buttons">
    <product-type-criterium-selector></product-type-criterium-selector>
  </div>
</div>

<new-projects
  *ngIf="selectedOverview === 'new'"
  (reloadCountChange)="reloadData.emit()"
>
</new-projects>

<quotation-container
  *ngIf="selectedOverview === 'quotation'"
  (reloadCountChange)="reloadData.emit()"
>
</quotation-container>

<site-visit-projects
  *ngIf="selectedOverview === 'site-visit'"
  (reloadCountChange)="reloadData.emit()"
>
</site-visit-projects>

<!-- subsecties nog toevoegen-->
<pending-container
  *ngIf="selectedOverview === 'pending'"
  (reloadCountChange)="reloadData.emit()"
  [parentSubject]="parentSubject"
>
</pending-container>
<!-- -->

<invoicing-projects
  *ngIf="selectedOverview === 'invoicing'"
  (reloadCountChange)="reloadData.emit()"
>
</invoicing-projects>

<executed-projects
  *ngIf="selectedOverview === 'executed'"
  (reloadCountChange)="reloadData.emit()"
>
</executed-projects>

<archived-projects
  *ngIf="selectedOverview === 'archived'"
  (reloadCountChange)="reloadData.emit()"
>
</archived-projects>

<delayed-projects
  *ngIf="selectedOverview === 'delayed'"
  (reloadCountChange)="reloadData.emit()"
></delayed-projects>

<search-projects *ngIf="selectedOverview === 'search'"> </search-projects>

<most-recent-placement-overview
  *ngIf="selectedOverview === 'most-recent-placement'"
></most-recent-placement-overview>
